export const defaultTableSize = 100

export const CUSTOMER_JOBS_TABLE = 'customer_jobs_columns'

export const CUSTOMER_ESTIMATES_TABLE = 'customer_estimates_columns'

export const CUSTOMER_JOBS_LIST = 'Jobs'

export const CUSTOMER_ESTIMATES_LIST = 'Estimates'

export const customerJobsDefaultColumnValues =
    [
        {name: 'invoice_number', title: '#', visible: true, sorted: 'none', _minWidth: 100},
        {name: 'date', title: 'Date', visible: true, sorted: 'none', _minWidth: 120},
        {name: 'customer', title: 'Customer', visible: true, sorted: 'none', _minWidth: 120},
        {name: 'address', title: 'Address', visible: true, sorted: 'none', _minWidth: 200},
        {name: 'description', title: 'Description', visible: true, sorted: 'none', _minWidth: 200},
        {name: 'lead_source', title: 'Lead source', visible: true, sorted: 'none', _minWidth: 120},
        {name: 'amount', title: 'Amount', visible: true, sorted: 'none', _minWidth: 120},
        {name: 'status', title: 'Status', visible: true, sorted: 'none', _minWidth: 120},
        {name: 'payment', title: 'Payment', visible: true, sorted: 'none', _minWidth: 120},
        {name: 'notes', title: 'Notes', visible: true, sorted: 'none', _minWidth: 200},
        {name: 'employees', title: 'Employees', visible: true, sorted: 'none', _minWidth: 120},
        {name: 'tags', title: 'Tags', visible: true, sorted: 'none', _minWidth: 120}
    ]

export const customerEstimatesDefaultColumnValues =
    [
        {name: 'invoice_number', title: '#', visible: true, sorted: 'none', _minWidth: 100},
        {name: 'date', title: 'Date', visible: true, sorted: 'none', _minWidth: 120},
        {name: 'customer', title: 'Customer', visible: true, sorted: 'none', _minWidth: 120},
        {name: 'address', title: 'Address', visible: true, sorted: 'none', _minWidth: 200},
        {name: 'description', title: 'Description', visible: true, sorted: 'none', _minWidth: 200},
        {name: 'lead_source', title: 'Lead source', visible: true, sorted: 'none', _minWidth: 120},
        {name: 'amount', title: 'Amount', visible: true, sorted: 'none', _minWidth: 120},
        {name: 'status', title: 'Status', visible: true, sorted: 'none', _minWidth: 120},
        {name: 'notes', title: 'Notes', visible: true, sorted: 'none', _minWidth: 200},
        {name: 'employees', title: 'Employees', visible: true, sorted: 'none', _minWidth: 120},
        {name: 'tags', title: 'Tags', visible: true, sorted: 'none', _minWidth: 120}
    ]
